var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcArrowRightFromLine({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.25 2.25H3.875V21.75H2.25V2.25Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.7261 15.7261L18.6398 12.8125H7.125V11.1875H18.6398L15.7261 8.27387L16.875 7.125L21.75 12L16.875 16.875L15.7261 15.7261Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcArrowRightFromLine);
export default __webpack_public_path__ + "static/media/ic-arrow-right-from-line.62e7891045fd50dab826a1e248271dfc.svg";
export { ForwardRef as ReactComponent };